module.exports = __webpack_public_path__ + "static/img/add-btn.846a87c9.png";